import React, {useEffect,useState} from 'react';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import Top from './Screens/Top'
import * as contentful from "contentful";
import ApiKey from "./Static/contentful";
import Footer from "./Components/Footer"

const App =()=>{
  const client = contentful.createClient(ApiKey)
  const [s0715, setS0715] = useState([])
  useEffect(() => {
    client
      .getEntries({
        order: '-sys.createdAt',
        'sys.contentType.sys.id': 'companies0715'
      })
      .then((res) => setS0715(res.items))
  },[]) //eslint-disable-line

  return(
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/"
          render={() => <Top companies={s0715}/>}
        />
      </Switch>
      <Footer />
    </BrowserRouter>
    );
}

export default App;
